import { ErrorMessages } from '../constants/Constants';

export const ExceptionHandler: any = {
  handleHttpError(httpResponse: any) {
    if (httpResponse) {
      switch (httpResponse.status) {
        case 400:
          this.handleBadRequest(httpResponse);
          break;
        case 401:
          this.handleUnauthorized(true);
          break;
        case 404:
          this.handleResourceNotFound();
          break;
        case 403:
        case 405:
          this.handleResourceNotAllow();
          break;
        default:
          this.handleInternalServerError(httpResponse);
          break;
      }
    } else {
      this.handleInternalServerError();
      //this.handleUnauthorized(true);
    }
    return httpResponse;
  },
  handleBadRequest(httpResponse: any) {
    // useNotifyMessage().notifyMessage(httpResponse.statusText || ErrorMessages.ErrorBadRequest, 'error');
    console.log('Error:', httpResponse.statusText || ErrorMessages.ErrorBadRequest);
  },
  handleUnauthorized(forceLogin: any) {
    //  useNotifyMessage().notifyMessage(ErrorMessages.ErrorUnauthorized);
    console.log('Error:', ErrorMessages.ErrorUnauthorized);
    // redirect to login screen
  },
  handleInternalServerError(httpResponse: any) {
    //  useNotifyMessage().notifyMessage(httpResponse.data.errorMessage || ErrorMessages.ErrorInternalServer);
    console.log('Error:', httpResponse.data.errorMessage || ErrorMessages.ErrorInternalServer);
  },
  handleResourceNotAllow() {
    // useNotifyMessage().notifyMessage(ErrorMessages.ErrorNotAllowPermission);
    console.log('Error:', ErrorMessages.ErrorNotAllowPermission);
  },
  handleResourceNotFound() {
    // useNotifyMessage().notifyMessage(ErrorMessages.ErrorResourceNotFound);
    console.log('Error:', ErrorMessages.ErrorResourceNotFound);
  },
  handleError(error: any) {
    const errMsg = error.message ? error.message : error;
    // useNotifyMessage().notifyMessage(errMsg);
    console.log('Error:', errMsg);
  },
};
